import { createSlice } from '@reduxjs/toolkit'

export interface IState {
  id: String
  name: String
  description: String
  status: String
  code: String
}

const initialState: IState = {
    id: "",
    name: "",
    description: "",
    status: "",
    code: "",
}

const institutionSlice = createSlice({
  name: 'institutionDetails',
  initialState,
  reducers: {
    setInstitutionDetails: (state, action) => {
      state.id = action.payload.id
      state.name = action.payload.name
      state.description = action.payload.description
      state.status = action.payload.status
      state.code = action.payload.code
    },
   
  },
})

export const {
    setInstitutionDetails
} = institutionSlice.actions
export default institutionSlice.reducer
